export default __webpack_public_path__ + "static/media/logo.8e5ddea6.svg";